import AdditionalField from '@/components/inputs/additional-field'
import CountrySelect from '@/components/inputs/country-select'
import EmailInput from '@/components/inputs/email-input-with-mailcheck'
import EmailOptInInput from '@/components/inputs/email-opt-in-input'
import EmailOptInWrapper from './email-opt-in-wrapper'
import EuDataProcessingConsent from '@/components/inputs/eu-data-processing-consent'
import FirstNameField from '@/components/inputs/first-name-field'
import LastNameField from '@/components/inputs/last-name-field'
import PartnershipOptInsInput from '@/components/inputs/partnership-opt-ins-input'
import PhoneNumberField from '@/components/inputs/phone-number-field'
import PostcodeField from '@/components/inputs/postcode-field'
import SmsOptInInput from '@/components/inputs/sms-opt-in-input'

export default {
  components: { AdditionalField, CountrySelect, EmailInput, EmailOptInInput, EmailOptInWrapper, EuDataProcessingConsent,
                FirstNameField, LastNameField, PartnershipOptInsInput, PhoneNumberField, PostcodeField, SmsOptInInput },

  methods: {
    additionalFieldValue(fieldName) {
      return this.action.additionalFields[fieldName]
    },

    componentForCommonField(fieldName) {
      switch (fieldName) {
      case 'country':
        return CountrySelect
      case 'email':
        return EmailInput
      case 'euDataProcessingConsent':
        return EuDataProcessingConsent
      case 'firstName':
        return FirstNameField
      case 'joinOrganisation':
        return EmailOptInWrapper
      case 'lastName':
        return LastNameField
      case 'optInSms':
        return SmsOptInInput
      case 'partnershipOptIns':
        return PartnershipOptInsInput
      case 'phoneNumber':
        return PhoneNumberField
      case 'postcode':
        return PostcodeField
      default:
        return AdditionalField
      }
    },

    extraPropsForCommonField(fieldConfig) {
      if (fieldConfig.isAdditionalField) {
        const { isAdditionalField, suppressForOneClick, ...rest} = fieldConfig

        return {
          id: `${this.entityType}-additional-field-${fieldConfig.name}`,
          fieldName: fieldConfig.name,
          initialValue: this.fieldValue(fieldConfig.name),
          ...rest
        }
      }

      switch (fieldConfig.name) {
      case 'email':
        return {
          labelOverride: fieldConfig.label,
          parentName: this.entityType,
          readonly: fieldConfig.readonly,
          required: true
        }
      case 'euDataProcessingConsent':
        return {
          explicitConsentRequired: fieldConfig.explicitConsentRequired,
          inputName: `${this.entityType}[eu_data_processing_consent]`,
          label: fieldConfig.label,
          showLabel: fieldConfig.explicitConsentRequired || fieldConfig.messagePosition === 'before_submit'
        }
      case 'joinOrganisation':
        return {
          globalSubscriptionData: fieldConfig.globalSubscriptionData,
          label: fieldConfig.label,
          regularData: fieldConfig.data,
          value: undefined // clear this attr since the component does not have a :value prop
        }
      case 'optInSms':
        return {
          label: fieldConfig.label,
          phoneNumberPresent: !!this.action.phoneNumber,
          smsOptInTypeData: fieldConfig.data,
          value: undefined // clear this attr since the component does not have a :value prop
        }
      case 'partnershipOptIns': {
        const {name, suppressForOneClick, ...rest} = fieldConfig
        return {
          initialValue: this.action.partnershipOptIns,
          value: undefined, // clear this attr since the component does not have a :value prop
          ...rest
        }
      }
      case 'phoneNumber':
        return {
          label: fieldConfig.label,
          required: fieldConfig.required
        }
      case 'postcode':
        return {
          label: fieldConfig.label
        }
      default:
        return {}
      }
    },

    fieldProps(field) {
      // `extraPropsForField` may have values of that should override those computed by the `fieldValue`,
      // so we give those values priority.
      const initialValue = this.fieldValue(field.name)
      return {
        value: initialValue,
        initialValue,
        ...this.extraPropsForField(field),
        ...field.validations
      }
    },

    updateCommonField({ action, fieldName, value, isAdditionalField }) {
      if (isAdditionalField) {
        this.setAdditionalFieldValue({action, field: fieldName, value})
      } else {
        switch (fieldName) {
        case 'joinOrganisation':
          this.setEmailOptInValues({action, value})
          break
        case 'optInSms':
          this.setSmsOptInValues({action, value})
          break
        default:
          this.setFieldValue({action, field: fieldName, value})
          break
        }
      }
    }
  }
}
